module.exports = __webpack_public_path__ + "img/yzy.1586952f.png";